const quickHelpLinks = {
  en: {
    trackAndTrace: 'https://www.unisportstore.com/track-and-trace/',
    return: 'https://www.unisportstore.com/faq/return/howtoreturn/',
    iframe: 'https://cust-unisportiframecom.web.app/'
  },
  sv: {
    trackAndTrace: 'https://www.unisportstore.se/track-and-trace/',
    return: 'https://www.unisportstore.se/retur/',
    iframe: 'https://cust-unisportiframesv.web.app/'
  },
  da: {
    trackAndTrace: 'https://www.unisport.dk/track-and-trace/',
    return: 'https://www.unisport.dk/retur/',
    iframe: 'https://cust-unisportiframeda.web.app/'
  },
  de: {
    trackAndTrace: 'https://www.unisportstore.de/track-and-trace/',
    return: 'https://www.unisportstore.de/retoure/',
    iframe: 'https://cust-unisportiframede.web.app/'
  },
  at: {
    trackAndTrace: 'https://www.unisportstore.at/track-and-trace/',
    return: 'https://www.unisportstore.at/retoure/',
    iframe: 'https://cust-unisportiframeat.web.app/'
  },
  fr: {
    trackAndTrace: 'https://www.unisportstore.fr/track-and-trace/',
    return:
      'https://www.unisportstore.fr/faq/retours/comment-retourner-un-article/',
    iframe: 'https://cust-unisportiframefr.web.app/'
  },
  fi: {
    trackAndTrace: 'https://www.unisportstore.fi/track-and-trace/',
    return:
      'https://www.unisportstore.fi/faq/palautus-reklamaatio/miten-ja-mista-palautan-tuotteen/',
    iframe: 'https://cust-unisportiframefi.web.app/'
  },
  nl: {
    trackAndTrace: 'https://www.unisportstore.nl/track-and-trace/',
    return:
      'https://www.unisportstore.nl/faq/annuleren-retour/hoe-kan-ik-iets-retourneren/'
  },
  nb: {
    trackAndTrace: 'https://www.unisportstore.no/track-and-trace/',
    return:
      'https://www.unisportstore.no/faq/retur-og-reklamasjon/retur-av-vare/',
    iframe: 'https://cust-unisportiframeno.web.app/'
  },
  pl: {
    trackAndTrace: 'https://www.unisport.pl/track-and-trace/',
    return: 'https://www.unisport.pl/faq/zwrot-zamowienia/zwrocic-zamowienie/'
  },
  it: {
    trackAndTrace: 'https://www.unisportstore.it/track-and-trace/',
    return:
      'https://www.unisportstore.it/faq/resi-e-rimborsi/come-funziona-il-reso/'
  }
};

export default quickHelpLinks;
